import { createSlice } from '@reduxjs/toolkit'

export interface tutorailState {
  displayTutorial: boolean
}

const initialState: tutorailState = {
  displayTutorial: false,
}

export const tutorailSlice = createSlice({
  name: 'tutorail',
  initialState,
  reducers: {
    displayTutorial: (state) => {
      state.displayTutorial = true
    },
    hideTutorial: (state) => {
      state.displayTutorial = false
    },
  },
})

export const { displayTutorial, hideTutorial } = tutorailSlice.actions

export default tutorailSlice.reducer
